import React, {useEffect, useRef, useState} from 'react';

import 'three';

import videojs from 'video.js';
import 'videojs-errors';
import 'videojs-vr/dist/videojs-vr';

import './ios.landscape.css';
import 'videojs-errors/dist/videojs-errors.css';
import 'videojs-vr/dist/videojs-vr.css';
import 'video.js/dist/video-js.css';
import 'videojs-playlist-ui/dist/videojs-playlist-ui.css';
import 'videojs-landscape-fullscreen';
import 'videojs-playlist';
import 'videojs-playlist-ui';
import {useGoToFullScreenOnAnyClick} from "./use-go-to-fullscreen-onanyclick";
import {usePlaylistSetup} from "./use-playlist-setup";
import {useVrSetup} from "./use-vr-setup";

const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
const isMobile = () => process.browser && /iPad|iPhone|Android/.test(navigator.userAgent);
export const  VideoPlayer = ({projection, debug, forceCardboard, playlist, vr, forceLandscape, panorama, ...videojsOptions}) => {
    const [player, setPlayer] = useState(null);
    const videoNode = useRef();
    const container = useRef();

    useEffect(() => {
        if (! videoNode || ! videoNode.current) {
            return;
        }
        let _player = videojs(videoNode.current, videojsOptions, function onPlayerReady() {
            console.log('onPlayerReady', this);
        });


        if ( _player.landscapeFullscreen ) {
            _player.landscapeFullscreen({
                fullscreen: {
                    enterOnRotate: true,
                    alwaysInLandscapeMode: true,
                    iOS: !!iOS
                }
            });
        }
        setPlayer(_player);

        return () => {
            console.log("Dispose!");
            if (_player) {
                _player.dispose();
            }

        }
    }, [videoNode]);

    useGoToFullScreenOnAnyClick(container, forceLandscape);
    usePlaylistSetup(playlist, player);
    useVrSetup({vr, debug, projection, forceCardboard, player});


    return (
        <div>
            <div data-vjs-player ref={ container }>
                <video  ref={ videoNode } autoPlay loop muted playsInline preload="auto"  className="video-js vjs-fluid"></video>
            </div>
            {/*{playlist && <div className="vjs-playlist"></div> }*/}
        </div>
    )

}
